(function () {
    'use strict';

    function contractorProjectDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/';

        function loadContractorProject(id) {
            return $http.get(baseUrl + 'ContractorProjects/' + id).then(function (response) {
                return response.data;
            });
        };

        function saveContractorProject(id, data) {
            return $http.put(baseUrl + id, data).then(
                function (response) { return true; }
            );
        };

        function deleteUploadBlob(blobReference) {
            return $http.get('/Files/DeleteUploadBlob?blobReference=' + blobReference).then(
                function (response) { return response.data; });
        };


        function deleteContractorProject(id) {
            return $http.delete(baseUrl + 'ContractorProjects/' + id).then(function (response) {
                return response.data;
            });
        }

        return {
            loadContractorProject: loadContractorProject,
            saveContractorProject: saveContractorProject,
            deleteUploadBlob: deleteUploadBlob,
            deleteContractorProject: deleteContractorProject
        }
    }

    contractorProjectDataService.$inject = ['$http'];

    angular.module('ecap.common').service('contractorProjectDataService', contractorProjectDataService);
})();
